import Vue from 'vue'
import Router from 'vue-router'
import CaseLibrary from '../components/CaseLibrary.vue'
import FloorPlanCreation from '../components/FloorPlanCreation.vue'
import ProjectManagement from '../components/ProjectManagement.vue'
import StyleReplacement from '../components/StyleReplacement.vue'
import SketchPlanCreation from '../components/SketchPlanCreation.vue'
import WhiteModelCreation from '../components/WhiteModelCreation.vue'
import SoftDecorationExtract from '../components/SoftDecorationExtract.vue'
import FurnitureCutoutRender from '../components/FurnitureCutoutRender.vue'
import SmartErase from '../components/SmartErase.vue'
import ObjectReplacement from '../components/ObjectReplacement.vue'
import FeaturePlaceholder from '../components/FeaturePlaceholder.vue'
import LoginPage from '../components/LoginPage.vue'
import HomeDashboard from '../components/HomeDashboard.vue'
import HighResolutionUpscale from '../components/HighResolutionUpscale.vue'
import OneClickCutout from '../components/OneClickCutout.vue'
import AspectRatioExpansion from '../components/AspectRatioExpansion.vue'
import GptPlayground from '../components/GptPlayground.vue'
import ReferralCommission from '../components/ReferralCommission.vue'
import FeedbackCenter from '../components/FeedbackCenter.vue'
import FeedbackDetail from '../components/FeedbackDetail.vue'
import AdminEntryPage from '../components/AdminEntryPage.vue'
import { authState, checkSession } from '../services/auth'
import { safeWorkflowReturnUrl } from '../utils/workflowAppUrl'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginPage,
      meta: { title: '登录', public: true }
    },
    {
      path: '/admin-entry',
      name: 'adminEntry',
      component: AdminEntryPage,
      meta: { title: '进入用户前台', public: true, impersonationEntry: true }
    },
    { path: '/', redirect: '/home' },
    {
      path: '/home',
      name: 'home',
      component: HomeDashboard,
      meta: { title: '首页', requiresAuth: true }
    },
    {
      path: '/playground',
      name: 'playground',
      component: GptPlayground,
      meta: { title: '耘图对话', requiresAuth: true }
    },
    {
      path: '/create',
      name: 'create',
      component: FloorPlanCreation,
      meta: { title: '平面转效果图', requiresAuth: true }
    },
    {
      path: '/line-draft-plan',
      name: 'lineDraftPlan',
      component: SketchPlanCreation,
      meta: { title: '线稿出方案', category: '平面创意', requiresAuth: true }
    },
    {
      path: '/real-scene-plan',
      name: 'realScenePlan',
      component: FeaturePlaceholder,
      meta: {
        title: '实景出方案',
        category: '平面创意',
        description: '毛坯房实景生成设计方案的入口已经预留，功能完成后会直接在这里开放。',
        requiresAuth: true
      }
    },
    {
      path: '/style-replace',
      name: 'styleReplace',
      component: StyleReplacement,
      meta: { title: '风格替换', requiresAuth: true }
    },
    {
      path: '/one-click-cutout',
      name: 'oneClickCutout',
      component: OneClickCutout,
      meta: { title: '一键抠图', category: '智能改图', requiresAuth: true }
    },
    {
      path: '/high-resolution',
      name: 'highResolution',
      component: HighResolutionUpscale,
      meta: { title: '高清放大', requiresAuth: true }
    },
    {
      path: '/aspect-ratio-expansion',
      name: 'aspectRatioExpansion',
      component: AspectRatioExpansion,
      meta: { title: '原图裁切', category: '原图裁切', requiresAuth: true }
    },
    {
      path: '/lighting-conversion',
      name: 'lightingConversion',
      component: StyleReplacement,
      props: { lightingMode: true },
      meta: { title: '灯光转换', requiresAuth: true }
    },
    {
      path: '/lighting-adjustment',
      name: 'lightingAdjustment',
      component: StyleReplacement,
      props: { lightingMode: true, lightingAdjustment: true },
      meta: { title: '灯光调节', requiresAuth: true }
    },
    {
      path: '/smart-erase',
      name: 'smartErase',
      component: SmartErase,
      meta: { title: '智能消除', requiresAuth: true }
    },
    {
      path: '/furniture-replacement',
      redirect: { name: 'furnitureReplacement' }
    },
    {
      path: '/selection-replacement',
      name: 'selectionReplacement',
      component: ObjectReplacement,
      props: { replacementType: 'generic' },
      meta: { title: '框选替换', category: '框选替换', requiresAuth: true }
    },
    {
      path: '/selection-replacement/curtain',
      name: 'curtainReplacement',
      component: ObjectReplacement,
      props: { replacementType: 'curtain' },
      meta: { title: '换窗帘', category: '框选替换', requiresAuth: true }
    },
    {
      path: '/selection-replacement/furniture',
      name: 'furnitureReplacement',
      component: ObjectReplacement,
      props: { replacementType: 'furniture' },
      meta: { title: '换家具', category: '框选替换', requiresAuth: true }
    },
    {
      path: '/selection-replacement/background',
      name: 'backgroundReplacement',
      component: ObjectReplacement,
      props: { replacementType: 'background' },
      meta: { title: '换背景', category: '框选替换', requiresAuth: true }
    },
    {
      path: '/selection-replacement/floor',
      name: 'floorReplacement',
      component: ObjectReplacement,
      props: { replacementType: 'floor' },
      meta: { title: '换地面', category: '框选替换', requiresAuth: true }
    },
    {
      path: '/selection-replacement/ceiling',
      name: 'ceilingReplacement',
      component: ObjectReplacement,
      props: { replacementType: 'ceiling' },
      meta: { title: '换吊顶', category: '框选替换', requiresAuth: true }
    },
    {
      path: '/selection-replacement/lighting-fixture',
      name: 'lightingFixtureReplacement',
      component: ObjectReplacement,
      props: { replacementType: 'lightingFixture' },
      meta: { title: '换灯具', category: '框选替换', requiresAuth: true }
    },
    {
      path: '/selection-replacement/door-window',
      name: 'doorWindowReplacement',
      component: ObjectReplacement,
      props: { replacementType: 'doorWindow' },
      meta: { title: '换门窗', category: '框选替换', requiresAuth: true }
    },
    {
      path: '/selection-replacement/cabinet',
      name: 'cabinetReplacement',
      component: ObjectReplacement,
      props: { replacementType: 'cabinet' },
      meta: { title: '换柜子', category: '框选替换', requiresAuth: true }
    },
    {
      path: '/object-replacement',
      redirect: { name: 'selectionReplacement' }
    },
    {
      path: '/hard-decoration-replacement',
      name: 'hardDecorationReplacement',
      component: FeaturePlaceholder,
      meta: {
        title: '换硬装',
        category: '智能改图',
        description: '墙面、地面等硬装替换功能的入口已经预留，功能完成后会直接在这里开放。',
        requiresAuth: true
      }
    },
    {
      path: '/white-model',
      name: 'whiteModel',
      component: WhiteModelCreation,
      meta: { title: '黑底线稿', category: '智能灯光', requiresAuth: true }
    },
    {
      path: '/lighting-draft-plan',
      redirect: '/white-model'
    },
    {
      path: '/soft-decoration-extract',
      name: 'softDecorationExtract',
      component: SoftDecorationExtract,
      meta: {
        title: '软装方案提取',
        category: '智能软装',
        description: '上传室内效果图，提取风格、配色、材质、关键单品与搭配建议，生成专业软装方案板。',
        requiresAuth: true
      }
    },
    {
      path: '/furniture-cutout-render',
      name: 'furnitureCutoutRender',
      component: FurnitureCutoutRender,
      meta: { title: '家具白底渲染', requiresAuth: true }
    },
    {
      path: '/furniture-scene-generation',
      name: 'furnitureSceneGeneration',
      component: FurnitureCutoutRender,
      props: { sceneMode: true },
      meta: {
        title: '家具环境生成',
        category: '智能软装',
        description: '上传单件家具图片，生成匹配空间、风格与光线的真实室内环境图。',
        requiresAuth: true
      }
    },

    {
      path: '/projects',
      name: 'projects',
      component: ProjectManagement,
      meta: { title: '客户项目管理', requiresAuth: true }
    },
    {
      path: '/referrals',
      name: 'referrals',
      component: ReferralCommission,
      meta: { title: '邀请分佣', requiresAuth: true }
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: FeedbackCenter,
      meta: { title: '我要提问', requiresAuth: true }
    },
    {
      path: '/feedback/:id',
      name: 'feedbackDetail',
      component: FeedbackDetail,
      meta: { title: '问题详情', requiresAuth: true }
    },
    {
      path: '/system-updates',
      redirect: '/home'
    },
    {
      path: '/cases',
      name: 'cases',
      component: CaseLibrary,
      meta: { title: '装修案例参考库', requiresAuth: true }
    },
    {
      path: '/materials',
      name: 'materials',
      component: () => import('../components/MaterialLibrary.vue'),
      meta: { title: '素材广场', requiresAuth: true }
    },
    { path: '*', redirect: '/home' }
  ]
})

router.beforeEach(async (to, from, next) => {
  if (to.meta.impersonationEntry) {
    next()
    return
  }
  // Revalidate protected navigations so an expired server session cannot remain
  // usable just because the client-side auth cache was previously populated.
  const authenticated = await checkSession(to.meta.requiresAuth === true)
  if (to.meta.public) {
    const workflowReturn = authenticated ? safeWorkflowReturnUrl(to.query.returnTo) : ''
    if (workflowReturn) {
      window.location.replace(workflowReturn)
      next(false)
      return
    }
    next(authenticated ? '/home' : undefined)
    return
  }
  if (!authenticated) {
    const referralCode = typeof to.query.code === 'string' ? to.query.code : ''
    next({ name: 'login', query: { redirect: to.fullPath, ...(referralCode ? { code: referralCode } : {}) } })
    return
  }
  if (to.meta.requiresAdmin && (!authState.user || String(authState.user.role).toUpperCase() !== 'ADMIN')) {
    next({ name: 'home' })
    return
  }
  next()
})

export default router
